var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 15.8193L3.75736 11.5767C1.41421 9.23345 1.41421 5.43449 3.75736 3.09134C6.10051 0.748198 9.89947 0.748198 12.2427 3.09134C14.5858 5.43449 14.5858 9.23345 12.2427 11.5767L8 15.8193ZM11.2998 10.6338C13.1223 8.81138 13.1223 5.8566 11.2998 4.03415C9.4774 2.2117 6.52261 2.2117 4.70017 4.03415C2.87772 5.8566 2.87772 8.81138 4.70017 10.6338L8 13.9337L11.2998 10.6338ZM8 8.66732C7.2636 8.66732 6.66667 8.07038 6.66667 7.33398C6.66667 6.5976 7.2636 6.00065 8 6.00065C8.7364 6.00065 9.33333 6.5976 9.33333 7.33398C9.33333 8.07038 8.7364 8.66732 8 8.66732Z",
    fill: "#96999C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.9c212c1fe6652bcfc5c40918278eb07b.svg";
export { ForwardRef as ReactComponent };